import { PhotoExportClassType } from 'shared'
import { useGlobalState } from 'context/GlobalStateContext'
import { usePhotoFilenamesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { PhotoFilenameContext } from './types'

const { Provider, useContextFn } = createStrictContext<PhotoFilenameContext>(
  'PhotoFilenameContext'
)

export const usePhotoFilenamesContext = useContextFn

const PhotoFilenamesProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading, refetch } = usePhotoFilenamesQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  return (
    <Provider
      value={{
        photoFilenames: PhotoExportClassType.map((classType) => ({
          ...classType,
          defaultTemplateItems: classType.defaultTemplateItems,
          templateItems:
            data?.photoFilenames?.records?.find(
              ({ classTypeId }) => classTypeId === classType.id
            )?.templateItems ?? null,
        })),
        loading,
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}

export default PhotoFilenamesProvider
